export default __webpack_public_path__ + "static/media/chemical-peels.445df9a4.pdf";